/**
 * SAAS-PORTAL — "Adicionar dispositivo" (FASE 5, portal do cliente).
 *
 * O cliente cola o CÓDIGO seguro de claim (fornecido pela equipe/instalador) e
 * o backend vincula o device ao seu tenant. NUNCA se reivindica por device_id
 * puro — o segredo é o código. Sucesso/erro vêm do backend (403 protegido, 409
 * já vinculado/expirado/usado, 404 código inválido).
 */
import { useState } from "react";
import { claimDevice } from "../lib/api.js";

export default function ClaimDevicePage({ onOpenDetail }) {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  async function handleClaim(e) {
    e.preventDefault();
    setError(null);
    setResult(null);
    if (!code.trim()) {
      setError("Cole o código de vínculo do dispositivo.");
      return;
    }
    setBusy(true);
    try {
      const out = await claimDevice(code.trim());
      setResult(out);
      setCode("");
    } catch (err) {
      setError(err?.message || "Não foi possível vincular o dispositivo.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="max-w-lg mx-auto space-y-4">
      <div>
        <h1 className="text-lg font-semibold text-noc-text">Adicionar dispositivo</h1>
        <p className="text-sm text-noc-muted mt-1">
          Cole o código de vínculo fornecido pela equipe para adicionar um
          dispositivo à sua empresa. O código é de uso único e expira.
        </p>
      </div>

      <form onSubmit={handleClaim} className="card p-5 space-y-4">
        <div className="space-y-1">
          <label className="label">Código de vínculo</label>
          <input
            value={code}
            onChange={(e) => setCode(e.target.value)}
            className="w-full h-10 px-3 rounded-lg bg-noc-bg border border-noc-border text-noc-text focus:border-noc-accent/60 outline-none font-mono text-sm"
            placeholder="cole o código aqui"
            spellCheck={false}
            autoComplete="off"
          />
        </div>

        {error && (
          <div className="flex items-center gap-2 text-sm text-noc-err bg-noc-err/10 border border-noc-err/30 rounded-lg px-3 py-2">
            <span className="led-err" />
            {error}
          </div>
        )}

        {result && (
          <div className="text-sm text-noc-ok bg-noc-ok/10 border border-noc-ok/30 rounded-lg px-3 py-2 space-y-2">
            <div>✅ Dispositivo <span className="font-mono">{result.device_id}</span> vinculado à sua empresa.</div>
            {onOpenDetail && (
              <button type="button" onClick={() => onOpenDetail(result.device_id)}
                className="btn-ghost h-8 px-3 text-xs">
                Abrir dispositivo
              </button>
            )}
          </div>
        )}

        <button type="submit" disabled={busy} className="btn-primary w-full h-10">
          {busy ? "Vinculando…" : "Vincular dispositivo"}
        </button>
      </form>
    </div>
  );
}
